import { useBrand } from '../BrandProvider.js';
import { brandDisplayName } from '../util/text.js';
import { Button } from './Button.js';

interface LoginPromptProps {
  onSignIn: () => void;
  /** Optional status line above the button (e.g. the session_revoked recovery hint). */
  notice?: string;
}

export function LoginPrompt({ onSignIn, notice }: LoginPromptProps): JSX.Element {
  const { brand } = useBrand();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--color-background)] p-6">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          {brand?.branding.logoUrl ? (
            <img
              src={brand.branding.logoUrl}
              alt={brand.name}
              className="h-12 w-auto mx-auto mb-4"
            />
          ) : null}
          <h1 className="font-display text-3xl tracking-tight text-[var(--color-text)]">
            {brand ? brandDisplayName(brand.name) : 'Portal'}
          </h1>
          {brand?.tagline ? (
            <p className="mt-2 text-sm text-[var(--color-muted)]">{brand.tagline}</p>
          ) : null}
        </div>

        <div className="rounded-lg border border-[rgb(var(--edge-rgb)/0.10)] glass p-6">
          <h2 className="font-display text-lg mb-2">Sign in</h2>
          <p className="text-sm text-[var(--color-muted)] mb-4">
            {notice ?? 'Use your work or Microsoft account to access the portal.'}
          </p>
          <Button variant="primary" size="lg" className="w-full" onClick={onSignIn}>
            Continue with Microsoft
          </Button>
          <p className="mt-4 text-xs text-[var(--color-muted)] text-center">
            Don't have access yet? Your administrator will send you an invitation.
          </p>
        </div>
      </div>
    </div>
  );
}
